import { evaluateRuntimeAdmission, type RuntimeAdmissionInput, type RuntimeAdmissionResult } from '@sbclite/core/container/runtime-admission'

export function evaluateEngineRuntime(input: RuntimeAdmissionInput, now: Date | number): RuntimeAdmissionResult {
  return evaluateRuntimeAdmission({ ...input, now: now instanceof Date ? now : new Date(now) })
}

export function runtimeAdmissionLabel(result: RuntimeAdmissionResult): string {
  if (result.eligible) return 'Ready'
  if (result.reason === 'RUNTIME_WAITING') return 'Needs configuration'
  if (result.reason === 'HEARTBEAT_STALE' || result.reason === 'PUBLICATION_STALE') return 'Last report stale'
  if (result.reason === 'RUNTIME_STATE_MISSING' || result.reason === 'RUNTIME_IDENTITY_INVALID' || result.reason === 'PUBLICATION_MISSING') return 'Not ready — runtime metadata unavailable'
  return 'Not ready'
}

export function runtimeAdmissionStatus(result: RuntimeAdmissionResult): 'healthy' | 'warning' {
  return result.eligible ? 'healthy' : 'warning'
}
